import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { MUSIC24_GENERAL_PLANS } from '../config/music24StripePlans';
import { formatPlanPrice, useDisplayCurrency } from '../config/useDisplayCurrency';

/**
 * The monthly price of the cheapest plan ("from $19 a month"), formatted in the display currency.
 * The number comes from the plan table of fym-shared (`MUSIC24_GENERAL_PLANS` is cheapest first).
 */
export function useLowestPlanPrice(): string | null {
  const intl = useIntl();
  const currency = useDisplayCurrency();
  return useMemo(() => {
    const cheapest = MUSIC24_GENERAL_PLANS[0];
    return cheapest === undefined ? null : formatPlanPrice(intl, cheapest.prices.monthly.amount, currency);
  }, [intl, currency]);
}
